<template>
  <div>
    <quillEditor
      v-model="content"
      :id="id"
      :options="options"
      ref="quill"
      @change="printDelta($event)"
      :uploadImageToHost="image => this.uploadImageToS3(image)"
      :afterUploadImageToHost="url => this.afterUploadImageToHost(url)"
      :largeFileError="e => this.largeFileError()"
    ></quillEditor>
    <small ref="largeFileLabel">
      {{ $t("news.new.maxSize") }}:
      <strong>500 kb.</strong>
    </small>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { Quill, quillEditor } from "./Quill";
import S3Service from "../lib/api/s3_handler";

export default {
  name: "Wysiwyg",
  components: {
    quillEditor
  },
  props: {
    placeholder: {
      type: String
    },
    id: {
      type: String,
      required: false
    },
    articleBody: {
      required: false,
      default: null
    },
    includeMediaContent: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      content: ""
    };
  },
  computed: {
    options: function() {
      const fonts = ["Audi", "Audi-extended"];
      const colors = ["#333333", "#12C464", "#FFAE50", "#36B6FE", "#FF4895"];
      const Font = Quill.import("formats/font");
      Font.whitelist = fonts;
      Quill.register(Font, true);

      const mediaContent = ["video"];
      let mediaOptions = ["link", "image"];

      if (this.includeMediaContent) {
        mediaOptions = mediaOptions.concat(mediaContent);
      }

      return {
        modules: {
          toolbar: [
            [
              { header: [1, 2, 3, 4, 5, 6, false] },
              { font: fonts },
              { color: colors },
              { size: ["small", false, "large", "huge"] }
            ],
            ["bold", "underline"],
            [{ align: [] }, { list: "ordered" }, { list: "bullet" }],
            mediaOptions,
            ["clean"]
          ]
        },
        placeholder: this.placeholder,
        theme: "snow"
      };
    }
  },
  watch: {
    articleBody: function(newValue) {
      this.setDelta();
    }
  },
  mounted: function() {
    this.setDelta();
  },
  methods: {
    setDelta: function() {
      const service = new S3Service();
      this.articleBody.ops = this.articleBody.ops.map(op => {
        if (op.insert.image)
          op.insert.image = service.signS3LinksFromText(op.insert.image);
        return op;
      });
      this.$refs.quill.quill.setContents(this.articleBody, "silent");
    },
    printDelta: function({ quill }) {
      const content = quill.editor.delta;
      this.$emit("updateBody", content);
    },
    uploadImageToS3: function(file) {
      const service = new S3Service();
      const timestamp = Date.now();
      const filename = `${timestamp}.${file.name.split(".").pop()}`;
      return service.uploadFile(filename, file);
    },
    afterUploadImageToHost: function(url) {
      const service = new S3Service();
      this.$refs.largeFileLabel.style.color = "black";
      return service.signS3LinksFromText(url);
    },
    largeFileError: function() {
      this.$refs.largeFileLabel.style.color = "red";
    }
  }
};
</script>

<style lang="scss">
.quill-editor {
  .ql-editor {
    @extend %audi-r;

    p {
      @extend %audi-r;
    }
    strong {
      font-weight: bold;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      @extend %audi-r;
    }
  }
  .ql-font {
    span[data-value="Audi"]::before {
      content: "Audi" !important;
      @extend %audi-r;
    }
    span[data-value="Audi-extended"]::before {
      content: "Audi-Ext" !important;
      @extend %audi-e;
    }
  }
  .ql-video {
    width: 500px;
    height: 300px;
  }
  .ql-font-Audi {
    @extend %audi-r;
  }
  .ql-font-Audi-extended {
    @extend %audi-e;
  }
}
</style>